import Box from '@zenbusiness/zui/Box';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';
import PropTypes from 'prop-types';

import LinkedBankAccountList from '#client/components/LinkBankAccountContainer/components/LinkedBankAccountList';
import useBankingAccounts from '#client/hooks/useBankingAccounts';
import useConstBusinessEntityUuid from '#client/hooks/useConstBusinessEntityUuid';
import useDisableDashboardContext from '#client/hooks/useDisableDashboardContext';
import useRedirectToLinkedAccounts from '#client/hooks/useRedirectToLinkedAccounts';

import EmptyState from './EmptyState';
import ListItemSkeleton from './ListItemSkeleton';
import SectionLink from './SectionLink';

export default function Banks({ loading = false, accounts, addBankHandler }) {
  const { isDisable } = useDisableDashboardContext();
  const { businessEntityUuid } = useConstBusinessEntityUuid();
  const { linkedAccountsPath } = useRedirectToLinkedAccounts(businessEntityUuid);
  const { id: bankingAccountId, loading: isFetchingBankingAccounts } = useBankingAccounts();
  const showSkeleton = isFetchingBankingAccounts || !bankingAccountId || loading;

  return (
    <Stack>
      {showSkeleton ? (
        <ListItemSkeleton />
      ) : (
        <>
          <Box
            alignItems="center"
            display="flex"
            justifyContent="space-between"
          >
            <Text
              size="lg"
              weight="medium"
            >
              Bank Accounts
            </Text>
            <SectionLink
              isDisabled={isDisable}
              text="See all"
              trackingProperties={{
                elementName: 'connected_accounts_see_all'
              }}
              url={linkedAccountsPath}
            />
          </Box>
          <Box>
            {accounts && accounts.length > 0 ? (
              <LinkedBankAccountList
                disable={loading || isDisable}
                listLinkedBankAccount={accounts}
                usedAt="dashboard"
              />
            ) : (
              <Box
                p="16px 0px"
                textAlign="center"
              >
                <EmptyState
                  onClick={addBankHandler}
                  text="Add a bank account"
                />
              </Box>
            )}
          </Box>
        </>
      )}
    </Stack>
  );
}

Banks.propTypes = {
  loading: PropTypes.bool,
  addBankHandler: PropTypes.func.isRequired,
  accounts: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};
